import { render, staticRenderFns } from "./parcours-bandeau.vue?vue&type=template&id=2593a4c7&scoped=true"
import script from "./parcours-bandeau.vue?vue&type=script&lang=js"
export * from "./parcours-bandeau.vue?vue&type=script&lang=js"
import style0 from "./parcours-bandeau.vue?vue&type=style&index=0&id=2593a4c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593a4c7",
  null
  
)

export default component.exports